export default function() {
  const widgetName = 'cardWidgetSubpageThemeBackgrounds';
  const widgetOpts = cardWidgetSubpageThemeBackgroundsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const $body = $('body');
      const $wrapper = $('.wrapper');
      function createHeroEl(num) {
        return `
          <div class="subpagetheme-hero-wrapper">
            <img class="subpagetheme-hero" src="${data.items[num].ImageWithPath}">
          </div>
        `;
      }
      if ($body.hasClass('subpage-theme--catering')) {
        $wrapper.prepend(createHeroEl(0));
      }
      if ($body.hasClass('subpage-theme--fair-rodeo')) {
        $wrapper.prepend(createHeroEl(1));
      }
      if ($body.hasClass('subpage-theme--first-interstate')) {
        $wrapper.prepend(createHeroEl(2));
      }
      if ($body.hasClass('subpage-theme--rv-park')) {
        $wrapper.prepend(createHeroEl(3));
      }                  

    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: false,
      margin: 10,
      navText: ['Prev','Next'],
      nav: false
    },
    textOverImage: false
  });

}